
/* injects from baggage-loader */

import React, { Component } from 'react';
import {t} from "../../../helpers/translator";
import PropTypes from "prop-types";
import CountDownComponent from "../countDownClock";

class ErrorLoggedInRFID extends Component {
    render () {
        return <div className="ticket-results-view-p">
            <CountDownComponent second={10}/>
            <div className="popup-message error"/>
            <h3>
                {t(this.props.text)}
            </h3>
        </div>;
    }
}

ErrorLoggedInRFID.propTypes = {
    text: PropTypes.string
};

export default ErrorLoggedInRFID;